export default "__VITE_ASSET__CCNDap5D__"